// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ChangeTextToIcon_wrapper__jXQbM","is_people":"ChangeTextToIcon_is_people__aQaUM","image":"ChangeTextToIcon_image__N8NZd","is_robot":"ChangeTextToIcon_is_robot__mm14I"};